import React, { useContext } from "react";
import FilterBar from "./FilterBar";
import MobileSubNav from "./MobileSubNav";
import NavContext from "contexts/NavContext";
import { ALC_DATA } from "utils/helpers";
const ConferenceNavigationButtons = [
	// { name: "All", link: "/publications/books/all" },

	{ name: "Conference Home", link: "/conference" },
	// {
	// 	name: "Event Details",
	// 	link: "/conference/attend",
	// 	items: [
	// 		// { name: "Register", link: "/conference/registration" },
	// 		{ name: "Know Before You Go", link: "/conference/attend/know-before-you-go" },
	// 		{ name: "Hotel & Travel", link: "/conference/travel" },
	// 		{ name: "Policies & Terms", link: "/conference/attend/policies" },
	// 		// { name: "Justify Your Attendance", link: "/conference/attend/justify" },
	// 		// { name: "First Timers", link: "/conference/attend/first-time" },
	// 	],
	// },
	// {
	// name: "Policies & Terms",
	// link: "/conference/attend/policies",
	// items: [
	// 	// { name: "Register", link: "/conference/registration" },
	// 	{ name: "Rate & Categories", link: "/conference/attend/rates" },
	// 	{ name: "Policies & Terms", link: "/conference/attend/policies" },
	// 	{ name: "Justify Your Attendance", link: "/conference/attend/justify" },
	// 	{ name: "First Timers", link: "/conference/attend/first-time" },
	// ],
	// },
	// {
	// 	name: "Program ",
	// 	link: "/conference/program",
	// 	items: [
	// 		// { name: "Keynote Speakers", link: "/conference/program/keynotes" },
	// 		{ name: "Vanguard Meeting", link: "/conference/program/vanguard" },
	// 		{ name: "Program Overview", link: "/conference/program/overview" },
	// 		{ name: "Schedule", link: "/conference/program/schedule" },
	// 		{ name: "Pre-Conference Courses", link: "/conference/program/pre-conf-courses" },
	// 		// { name: "Communities of Practice", link: "/conference/program/communities-of-practice" },
	// 		// { name: "Workshop Volunteers", link: "/conference/program/proposal" },
	// 		// { name: "First Timers", link: "/conference/attend/first-time" },
	// 	],
	// },
	// { name: "Proposals", link: "/conference/proposal" },
	// { name: "Volunteers", link: "/conference/volunteer" },
	// { name: "Schedule", link: "/conference/schedule" },
	// { name: "Career Corner", link: "/conference/workshop" },

	{ name: "Sponsors & Partners", link: "/conference/sponsors" },
	// { name: "About", link: "/conference/about" },
	// { name: "Mobile App", link: "/conference/app" },
];

ConferenceNavigationButtons.title = `${ALC_DATA.year} AAPL Annual Leadership Conference`;

const Desktop = ({ megaNavName, userDropdownOpen }) => {
	const { scrollHeaderLimit } = useContext(NavContext);

	return (
		<FilterBar
			isSlimNav={scrollHeaderLimit}
			filterButtons={ConferenceNavigationButtons}
			hideAssessment={true}
			subNavScroll={0}
			isMiniSiteSubNav={true}
			className={megaNavName || userDropdownOpen ? "z-index-neg-1" : ""} //this class is made global in Layout.js
			withScroll={true}
		/>
	);
};

const Mobile = () => {
	return <MobileSubNav withScroll={true} subNavScroll={0} navigation={ConferenceNavigationButtons} />;
};
//Sub navs
export default {
	Mobile: Mobile,
	Desktop: Desktop,
};
